module.exports = __webpack_public_path__ + "static/media/apex3.330ae641.png";